import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function SkeletonDisplay(_: Props) {
  return (
    <div className={styles.group}>
      <div className={styles.groupHeader}>
        <div>
          <h2 className={styles.name}>
            <Skeleton />
            <Skeleton />
          </h2>
          <p className={styles.members}>
            <Skeleton />
          </p>
        </div>
      </div>
      <div className={styles.resourcesList}>
        <ul className={styles.list}>
          <div className={styles.elem}>
            <Skeleton />
            <Skeleton />
          </div>
          <div className={styles.elem}>
            <Skeleton />
            <Skeleton />
          </div>
          <div className={styles.elem}>
            <Skeleton />
            <Skeleton />
          </div>
        </ul>
      </div>
    </div>
  );
}

export { SkeletonDisplay };
